<template>
    <div class="container">
        <smtp-settings-component></smtp-settings-component>
        <onesignal-settings-component></onesignal-settings-component>
    </div>
</template>

<script>
import smtpSettings from './elements/smtp_settings.vue'
import onesignalSettings from './elements/onesignal_settings.vue'
import loader from './elements/loader.vue'

export default {
    components: {
        'smtp-settings-component': smtpSettings,
        'loader-component': loader,
        'onesignal-settings-component': onesignalSettings
    },
}
</script>



// WEBPACK FOOTER //
// src/components/aquazor-settings.vue